export default "__VITE_ASSET__CHZ0ruvY__"